import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'

const CareerInfoGraphic = ({ title, images, subtitle, components }) => {
  const imageByText = components[0].subtitle.subtitle.split('\n')
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.imageBox}>
          <GatsbyImage
            image={images[0].gatsbyImageData}
            style={{ height: '100%', width: '100%' }}
            alt={images[0]?.description}
          />
          <div className={styles.byText}>
            <div className={styles.description}>{imageByText[0]}</div>
            <div className={styles.name}>{imageByText[1]}</div>
            <div className={styles.designation}>{imageByText[2]}</div>
          </div>
        </div>
        <div className={styles.textBox}>{subtitle.subtitle}</div>
      </div>
    </div>
  )
}

export default CareerInfoGraphic
